<template>
  <div class="stock-award">
    <el-form :model="stockAwardForm"
             size="small"
             label-position="top"
             ref="stockAwardForm">
      <el-form-item :label="$xinI18n('融资轮次','home-rongzilunci')+'：'" prop="round">
        <el-select v-model="stockAwardForm.round">
          <el-option v-for="(item,key) in roundMapOption" :label="item" :value="key" :key="key">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$xinI18n('员工职位','home-yuangongzhiwei')+'：'" prop="title">
        <el-select v-model="stockAwardForm.title">
          <el-option v-for="(item,key) in titleMapOption" :label="item" :value="key" :key="key">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$xinI18n('期权池','home-qiquanchi')+'：'" prop="stock">
        <el-select v-model="stockAwardForm.stock">
          <el-option v-for="(item,key) in stockMapOption" :label="item" :value="key" :key="key">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="count-result" v-if="stockResult">
      <div class="count-result-title">
        <h4>{{ $xinI18n('计算结果','home-jisuanjieguo') }}</h4>
      </div>
      <p>{{stockResult}}</p>
    </div>
  </div>
</template>

<script lang="ts">
  import {Component, Vue} from 'vue-property-decorator';
  import {HomeApi} from '@/module/home/service/home-api.service';
  import {XinMessage} from '@xin/xin-ui';

  @Component({
    name: 'stock-award'
  })
  export default class StockAward extends Vue {
    public stockAwardForm = {
      submit: 1,
      round: '1',
      stock: '1',
      title: '1'
    };
    public roundMapOption = {};
    public stockMapOption = {};
    public titleMapOption = {};
    public stockResult = '';

    public $refs!: {
      stockAwardForm: any
    };

    mounted() {
      this.getInitParams();
    }

    public getInitParams() {
      HomeApi.getStockInitParams().then(result => {
        if (result.status) {
          this.roundMapOption = result.data.roundMap;
          this.stockMapOption = result.data.stockMap;
          this.titleMapOption = result.data.titleMap;
        }
      });
    }

    /**
     * 开始计算
     */
    startToCalculator() {
      let postData = this.stockAwardForm;
      postData.submit = 1;
      this.$refs.stockAwardForm.validate((valid: boolean) => {
        if (valid) {
          HomeApi.stockSward(postData).then((res: any) => {
            if (res.status) {
              XinMessage.success(res.message);
              this.stockResult = res.data;
            } else {
              XinMessage.error(window.$xinI18n('报错啦~~~','home-baocuola'));
            }
          });
        } else {
          return false;
        }
      });
    }
  }
</script>

<style lang="scss" scoped>
  @import "stock-award";
</style>
